module.exports = __webpack_public_path__ + "dd56fe510f53e1dea631122a2b7118e8.jpeg";